import * as React from 'react';
import { IReceiptConfirmationProps } from './LocalShipmentOutputDialog.properties';
import FormViewModal from 'components/common/Modals/FormViewModal';
import { IActionItem } from 'components/common/Modals/FormViewModal.properties';
import LocalShipmentOutputDialogForm from './LocalShipmentOutputDialog.form';
import { showSnackBar } from 'components/common/SnackBars/SnackBar.hooks';

const LocalShipmentOutputDialog = (props: IReceiptConfirmationProps): JSX.Element => {
  const {
    open, values, onOk: onApply, setUnpackingReportDocumentOutputOptions, clearUnpackingReportDocumentOutputOptions,
    onCancel, initialValues, currentUserId, formSyncErrors, isProcessing, customerId
  } = props;

  const confirmationActions = (): IActionItem[] => {
    return [
      {
        title: 'Ok',
        disabled: !!isProcessing,
        listener: () => {
          if (isValidFormData()) {
            onApply({
              ...values,
            });
          }
        }
      },
      {
        title: 'Cancel',
        isDefault: true,
        listener: () => {
          onCancel();
        }
      }
    ];
  };

  const isValidFormData = (): boolean => {
    if (formSyncErrors && Object.keys(formSyncErrors).length > 0) {
      const requiredError = Object.entries(formSyncErrors).find((item) => item.includes('Required'));
      if (requiredError) {
        showSnackBar({ variant: 'warning', message: 'Please fill in required fields.' });
      } else {
        const firstError = Object.keys(formSyncErrors)[0];
        showSnackBar({ variant: 'warning', message: `Please enter valid ${firstError}` });
      }

      return false;
    }

    return true;
  };

  React.useEffect(
    () => {
      if (initialValues && open) {
        setUnpackingReportDocumentOutputOptions(initialValues?.LocalShipmentDespatchOutput?.inlineObject ?? initialValues?.LocalShipmentDespatchOutput);
      } else {
        clearUnpackingReportDocumentOutputOptions();
      }
    },
    [initialValues, open]);

  return (<FormViewModal
    open={open}
    loading={false}
    title={'Shipment Despatch Confirmation'}
    formProps={{
      style: {
        height: '585px',
        minWidth: '535px'
      },
      formSchema: LocalShipmentOutputDialogForm,
      customerId: customerId,
      initialValues: {
        ...initialValues,
        LocalShipmentDespatchOutput: initialValues && initialValues?.LocalShipmentDespatchOutput ? initialValues.LocalShipmentDespatchOutput?.inlineObject?.PrinterLocation ?? initialValues.LocalShipmentDespatchOutput?.PrinterLocation : '',
        UserId: currentUserId,
      },
      valuesSchema: initialValues ? initialValues?.schema : {},
    }}
    actions={confirmationActions()}
    dialogActionsButtons={true}
    dialogActionsShadow={false}
  />);
};

export default LocalShipmentOutputDialog;
